import React from "react";
import { Paper, Typography, Stack, Avatar } from "@mui/material";

const OrdersBreakdown = ({ amOrders, pmOrders }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Orders Breakdown
      </Typography>
      <Stack spacing={2}>
        <Paper variant="outlined" sx={{ p: 2, bgcolor: "#fff3e0" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar sx={{ width: 12, height: 12, bgcolor: "#ef6c00" }} />
              <Typography fontWeight="medium">Morning Shift (AM)</Typography>
            </Stack>
            <Typography fontWeight="bold" color="#ef6c00">
              {amOrders} orders
            </Typography>
          </Stack>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f3e5f5" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar sx={{ width: 12, height: 12, bgcolor: "#7b1fa2" }} />
              <Typography fontWeight="medium">Evening Shift (PM)</Typography>
            </Stack>
            <Typography fontWeight="bold" color="#7b1fa2">
              {pmOrders} orders
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </Paper>
  );
};

export default OrdersBreakdown;
